"use strict";
/**
 * Logic - process trees which contain logic variables
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueSetForVariableWithWorkerThreads = exports.getValueSetForVariable = exports.resolveBoolean = exports.getVariablesMetadata = exports.addVariablesToContext = exports.resolveLogic = exports.resolveTree = exports.resolveVar = exports.SOURCE_ATTRIBUTE = exports.FALLBACK_ATTRIBUTE = exports.STYLE_PROPERTY = void 0;
const traverse_1 = __importDefault(require("traverse"));
const consts_1 = require("./consts");
const evaluator_1 = require("./evaluator");
const vlx_types_1 = require("@sundaysky/vlx-types");
const dataContext_1 = require("./dataContext");
const resolveVariableWithWorkerThread_1 = require("./resolveVariableWithWorkerThread");
exports.STYLE_PROPERTY = "@style";
exports.FALLBACK_ATTRIBUTE = "fallback";
exports.SOURCE_ATTRIBUTE = "source";
/**
 * Test a list of rules and return a list of matching conditions, up to the specified limit
 * @param listConditions
 * @param isTrue
 * @param limit
 */
const resolveRules = (listConditions, isTrue, limit = 1) => {
    let result = [];
    for (let i = 0; i < listConditions.length; ++i) {
        let condition = listConditions[i];
        if (condition.when === undefined || condition.when == null || isTrue(condition.when)) {
            result.push(condition);
            if (limit > 0 && result.length === limit) {
                break;
            }
        }
    }
    return result.length === 0 ? null : result;
};
/**
 * duck typing:
 * A variable will always have a type field, and either a single value, or a list of rules
 * @param o
 * @returns {*|CssRule[]|string|Array}
 */
const isVariableDefinition = (o) => {
    return (o) && (o.type) && (o.value || o.rules);
};
/**
 * extract information on cardinality from the variable definition
 * @param varDef
 * @returns {*|{multiple: boolean, limit: null}}
 */
const variableCardinality = (varDef) => {
    var _a;
    return (_a = varDef === null || varDef === void 0 ? void 0 : varDef.cardinality) !== null && _a !== void 0 ? _a : { multiple: false, limit: undefined };
};
const isEvalExpression = (obj) => {
    return (obj && typeof obj === "object" && typeof obj["eval"] === "string" && Object.keys(obj).length == 1);
};
const getEvalExpression = (obj) => {
    return obj && obj["eval"];
};
/**
 * Macros are deliniated by [[macro]], this will expand any macros in all text fields within the obj
 * @param obj
 * @param context
 * @returns {*}
 */
const expandMacrosInObject = (obj, context) => {
    if (obj) {
        if (typeof obj === "string") {
            obj = (0, evaluator_1.textMacro)(obj, context);
        }
        else if (isEvalExpression(obj)) {
            obj = (0, evaluator_1.evaluate)(getEvalExpression(obj), context);
        }
        else if (typeof obj === "object") {
            obj = (0, traverse_1.default)(obj).map(function (elem) {
                if (typeof elem === "string") {
                    this.update((0, evaluator_1.textMacro)(elem, context), true);
                }
                else if (isEvalExpression(elem)) {
                    this.update((0, evaluator_1.evaluate)(getEvalExpression(elem), context), true);
                }
            });
        }
    }
    return obj;
};
const transformListVariable = (list, transform) => {
    if (transform && transform === "slots") {
        let ret = {};
        let slot = "A";
        for (let i of list) {
            ret[`slot${slot}`] = i;
            slot = String.fromCharCode(slot.charCodeAt(0) + 1);
        }
        ret[consts_1.VALID_SLOTS] = list.length;
        return ret;
    }
    else
        return list;
};
/**
 * Resolve a single variable based on its definition, and the provided context of data elements
 *
 * @param variableDefinition
 * @param context
 * @param resultProcessor - an optional func to walk all results
 * @returns {*}
 */
const resolveVar = (variableDefinition, context, resultProcessor) => {
    let resultValue = null;
    let resultCase = null;
    if (!isVariableDefinition(variableDefinition)) {
        return { value: variableDefinition };
    }
    const card = variableCardinality(variableDefinition);
    if (variableDefinition.value !== undefined) {
        // we have a static result
        resultValue = variableDefinition.value;
        // expand macros in static result
        resultValue = expandMacrosInObject(resultValue, context);
    }
    else if (variableDefinition.rules) {
        // run the rule conditions...
        let results = resolveRules(variableDefinition.rules, (s => (0, evaluator_1.conditionMacro)(s, context)), card.multiple ? (card.limit || null) : 1);
        // prioritized list object - always return with $validSlots: #, even if it's 0 (all conditions came out false)
        if (!results && card.multiple && card.transform === "slots") {
            results = [];
        }
        if (results) {
            // handle macros
            results.forEach(r => r.value = expandMacrosInObject(r.value, context));
            // is this a singleton, or a list result?
            if (card.multiple) {
                resultValue = results.map(r => r.value);
                // transform value to final form
                if (card.transform) {
                    resultValue = transformListVariable(resultValue, card.transform);
                }
                resultCase = results;
            }
            else {
                // if single, return only one element
                resultValue = results[0] && results[0].value;
                resultCase = results[0];
            }
        }
    }
    // run the result processor if provided to us
    if (resultValue !== undefined && resultProcessor) {
        resultValue = resultProcessor(resultValue, variableDefinition.type, context);
    }
    return {
        value: resultValue,
        case: resultCase
    };
};
exports.resolveVar = resolveVar;
const transformArrayOfObjectsToObject = (array) => {
    return array.reduce((acc, cur) => (Object.assign(acc, cur)), {});
};
const makePath = (metadata, path, value) => {
    let leafObj = path.slice(0, -1).reduce((a, v) => a[v] = a[v] || {}, metadata);
    let leafKey = path.slice(-1)[0];
    if (leafKey) {
        leafObj[leafKey] = value !== null && value !== void 0 ? value : null;
    }
};
const resolveTree = (tree, context, resultProcessor) => {
    let metadata = {};
    let resolvedVariables = (0, traverse_1.default)(tree).map(function (elem) {
        if (elem && elem["bypass_vlx_logic"] === true) {
            // for sending an already resolved element from the hub-fe
            // used for chaptering sent from vlxOverrides in the hub-fe
            delete elem["bypass_vlx_logic"];
        }
        else if (isVariableDefinition(elem)) {
            let resolved = (0, exports.resolveVar)(elem, context, resultProcessor);
            switch (elem.type) {
                case "compound": {
                    for (let key in resolved.value) {
                        const myItem = resolved.value[key];
                        if (myItem.type === consts_1.HOTSPOT) {
                            let hotspotObj = {};
                            for (let hsProp in myItem.value) {
                                hotspotObj[hsProp] = myItem.value[hsProp].value;
                            }
                            this.parent.node[key] = hotspotObj;
                        }
                        else {
                            this.parent.node[key] = myItem.value;
                        }
                    }
                    this.remove(true);
                    break;
                }
                case consts_1.HOTSPOT: {
                    for (let key in resolved.value) {
                        this.parent.node[key] = resolved.value[key].value;
                    }
                    this.remove(true);
                    break;
                }
                case "image":
                case "video":
                case "media": {
                    let updatedValue;
                    if (resolved) {
                        if (elem[exports.STYLE_PROPERTY]) {
                            updatedValue = Object.assign(Object.assign(Object.assign({}, resolved.value), { "@type": "media" }), elem[exports.STYLE_PROPERTY]);
                        }
                        else {
                            updatedValue = resolved.value;
                        }
                        if (isVariableDefinition(elem[exports.FALLBACK_ATTRIBUTE])) {
                            let resolvedFallback = (0, exports.resolveVar)(elem[exports.FALLBACK_ATTRIBUTE], context, resultProcessor);
                            if ((resolvedFallback === null || resolvedFallback === void 0 ? void 0 : resolvedFallback.value) && (updatedValue[exports.SOURCE_ATTRIBUTE] !== resolvedFallback.value[exports.SOURCE_ATTRIBUTE])) {
                                updatedValue[exports.FALLBACK_ATTRIBUTE] = resolvedFallback.value[exports.SOURCE_ATTRIBUTE];
                            }
                        }
                    }
                    this.update(updatedValue, true);
                    break;
                }
                case "text": {
                    let updatedValue;
                    if (resolved) {
                        if (elem[exports.STYLE_PROPERTY]) {
                            const text = typeof resolved.value === "string" ? { "text": resolved.value } : resolved.value;
                            updatedValue = Object.assign(Object.assign(Object.assign({}, text), { "@type": "text" }), elem[exports.STYLE_PROPERTY]);
                        }
                        else {
                            updatedValue = resolved.value;
                        }
                    }
                    this.update(updatedValue, true);
                    break;
                }
                default: {
                    this.update(resolved && resolved.value, true);
                }
            }
            // save metadata about which case was matched
            makePath(metadata, this.path, resolved.case);
        }
        else if ((elem === null || elem === void 0 ? void 0 : elem.type) === "layered") {
            const type = elem.type;
            delete elem.type;
            const updatedValue = Object.assign({ "@type": type }, elem);
            this.update(updatedValue, false);
        }
    });
    // transform prioritized lists in resolvedVariables
    if (typeof resolvedVariables === "object") {
        for (let dataItemName in resolvedVariables) {
            let dataItem = resolvedVariables[dataItemName];
            if (dataItem && dataItem[consts_1.VALID_SLOTS] !== undefined) { // dataItem is prioritized list
                const myPL = Object.keys(dataItem).map(slotName => {
                    const slotContent = dataItem[slotName];
                    if (slotName === consts_1.VALID_SLOTS) {
                        return { [slotName]: slotContent };
                    }
                    else {
                        let newSlotContent = {};
                        Object.keys(slotContent).forEach(phName => {
                            if (slotContent[phName].type === consts_1.HOTSPOT) {
                                let hotspot = {};
                                Object.keys(slotContent[phName].value).forEach(hotspotProp => {
                                    hotspot[hotspotProp] = slotContent[phName].value[hotspotProp].value;
                                });
                                newSlotContent[phName] = hotspot;
                            }
                            else if (slotContent[phName].type) {
                                newSlotContent[phName] = slotContent[phName].value;
                            }
                            else { // backwards compatibility
                                newSlotContent[phName] = slotContent[phName];
                            }
                        });
                        return { [slotName]: newSlotContent };
                    }
                });
                resolvedVariables[dataItemName] = transformArrayOfObjectsToObject(myPL);
            }
        }
    }
    // preserve metadata information about all variables
    resolvedVariables[vlx_types_1.METADATA] = metadata;
    return resolvedVariables;
};
exports.resolveTree = resolveTree;
const resolveLogic = (objWithVariables, dataContext, mediaResolver) => {
    return (0, exports.resolveTree)(objWithVariables, dataContext, mediaResolver);
};
exports.resolveLogic = resolveLogic;
/**
 *
 * @param listElements - an array of elements, of the form { name: 'name', value: { vardef } }
 * @param context - initial context for rule evaluation
 * @param insertionPath -  path (in the form of an array of properties) under which to insert elements
 *                         when not provided, elements are inserted in root of context
 * @param resultProcessor
 */
const addVariablesToContext = (listElements, context, insertionPath, resultProcessor) => {
    if (!insertionPath) {
        insertionPath = [];
    }
    // we want to insert at same level as dataelements, which might not be root of object
    // todo: the whole wrap/unwrap thing is in the code for backward compatibility for access to dataelements
    // that are not through the de() functions. I think they can be removed at this point. (--jm)
    let insertionRoot = (0, evaluator_1.getDataElementRoot)(context);
    if (!Array.isArray(listElements)) {
        return;
    }
    let metadata = (0, vlx_types_1.getMetadata)(insertionRoot) || (insertionRoot[vlx_types_1.METADATA] = {});
    for (const v of listElements) {
        // does this look like an element definition?
        if (v && v.name && v.value) {
            // where to insert the variable
            let path = [...insertionPath, v.name];
            let value = v.value;
            // is the value dynamic? then resolve it as a variable
            if (isVariableDefinition(value)) {
                let resolved = (0, exports.resolveVar)(value, context, resultProcessor);
                value = resolved && resolved.value;
                // save metadata about which case was matched
                makePath(metadata, path, resolved.case);
            }
            makePath(insertionRoot, path, value);
        }
    }
};
exports.addVariablesToContext = addVariablesToContext;
const getVariablesMetadata = (tree) => {
    return (0, vlx_types_1.getMetadata)(tree);
};
exports.getVariablesMetadata = getVariablesMetadata;
/**
 * resolve a condition which results in a boolean
 * @param boolDef
 * @param context
 * @returns {boolean}
 */
const resolveBoolean = (boolDef, context) => {
    if (typeof boolDef === "boolean") {
        return boolDef;
    }
    if (typeof boolDef === "string") {
        return (0, evaluator_1.conditionMacro)(boolDef, context);
    }
    else if (isVariableDefinition(boolDef)) {
        let result = (0, exports.resolveVar)(boolDef, context);
        return result && result.value && result.value != "false";
    }
    return false;
};
exports.resolveBoolean = resolveBoolean;
/**
 * Calculate the set of values for variable after checking all permutation of data elements value sets.
 * Assumes the value set includes the no-value
 *
 * @param variableDefinition variable definition
 * @param contextWithValueSetArray a list of data elements with their value sets
 * @returns a set of values for variable
 */
const getValueSetForVariable = (variableDefinition, contextWithValueSetArray) => {
    const variableValueSet = new Set();
    const stringifiedLogic = JSON.stringify(variableDefinition); // since resolveLogic modifies the object, we make a deep copy of it: We stringify once and parse per resolveVariable
    const permute = (contextWithValuesArray, context = {}) => {
        if (contextWithValuesArray.length === 0) {
            const permutationValue = (0, exports.resolveVar)(JSON.parse(stringifiedLogic), (0, dataContext_1.wrapDataContext)(context));
            variableValueSet.add(permutationValue.value);
        }
        else {
            const currentDataElementWithValues = contextWithValuesArray[0];
            const nextContextWithValuesArray = contextWithValuesArray.slice(1);
            // Value set
            for (const value of currentDataElementWithValues.values) {
                permute(nextContextWithValuesArray, Object.assign(Object.assign({}, context), { [currentDataElementWithValues.name]: value }));
            }
        }
    };
    permute(contextWithValueSetArray);
    return variableValueSet;
};
exports.getValueSetForVariable = getValueSetForVariable;
/**
 * This implementation collects all inputs to resolveVariable, and then calls resolveVariableWithMultipleWorkerThreads
 *
 * Calculate the set of values for variable after checking all permutation of data elements value sets.
 * Assumes the value set includes the no-value
 *
 * @param variableDefinition variable definition
 * @param contextWithValueSetArray a list of data elements with their value sets
 * @returns a set of values for variable
 */
const getValueSetForVariableWithWorkerThreads = (variableDefinition, contextWithValueSetArray, workers) => __awaiter(void 0, void 0, void 0, function* () {
    const stringifiedLogic = JSON.stringify(variableDefinition); // since resolveLogic modifies the object, we make a deep copy of it: We stringify once and parse per resolveVariable
    // collect args for workers
    const args = [];
    // Gather all "tasks" to run in parallel
    const permute = (contextWithValuesArray, context = {}) => {
        if (contextWithValuesArray.length === 0) {
            args.push([JSON.parse(stringifiedLogic), (0, dataContext_1.wrapDataContext)(context)]);
        }
        else {
            const currentDataElementWithValues = contextWithValuesArray[0];
            const nextContextWithValuesArray = contextWithValuesArray.slice(1);
            // Value set
            for (const value of currentDataElementWithValues.values) {
                permute(nextContextWithValuesArray, Object.assign(Object.assign({}, context), { [currentDataElementWithValues.name]: value }));
            }
        }
    };
    permute(contextWithValueSetArray);
    // Run tasks in parallel with concurrency limit
    const results = yield (0, resolveVariableWithWorkerThread_1.resolveVariableWithMultipleWorkerThreads)(args, workers);
    return new Set(results.map(result => result.value));
});
exports.getValueSetForVariableWithWorkerThreads = getValueSetForVariableWithWorkerThreads;
//# sourceMappingURL=logic.js.map